/* eslint-disable import/prefer-default-export */
import { SearchState } from '@customTypes/search';
import { GetAppliedFiltersCount } from '@context/SearchContext2025';
import { GetCanonicalURL } from '@helpers/environment';
import { GenerateSearchUrl } from '@helpers/url';

/**
 * Generates a canonical URL for the SRP (Search Results Page) based on the provided SearchState.
 * This function is used to create a consistent URL format for search results.
 *
 * @param s - The SearchState object containing search parameters.
 * @returns string - The canonical URL for the SRP.
 */
export function getSRPCanonicalURL(s: SearchState): string {
  // Generate the search URL using the provided SearchState
  const searchPath = GenerateSearchUrl(s);
  const searchUrl = new URL(searchPath, 'http://localhost'); // Use a dummy base URL for URL parsing
  const rootCanonicalURL = GetCanonicalURL(searchPath);
  // NOTE: Future iteration will have a priority map of amenities and filters we want to
  // allow for indexation. But the first version, we are only going to allow indexation
  // of the first query parameter.

  // Count how many filter are applied
  if (GetAppliedFiltersCount(s) === 1) {
    const searchParam = searchUrl.search.includes('&')
      ? searchUrl.search.split('&')[0]
      : searchUrl.search;
    return `${rootCanonicalURL}${searchParam}`;
  }
  return rootCanonicalURL;
}
